/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapAreaDisplay', {
            bindings: {
                model: '<',
                onStateRemoved: '&',
                onSiteRemoved: '&'
            },
            templateUrl: 'app/region/dashboard/area/areaDisplay/area.display.component.html',
            controller: areaDisplayController,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function areaDisplayController(utilitiesService) {
        var vm = this;

        vm.removeSites = removeSites;
        vm.deselectState = deselectState;

        function deselectState(state) {
            var index = utilitiesService.getIndexOf(vm.model.states, 'id', state.id);
            vm.onStateRemoved({ index: index });
        }

        function removeSites(index) {
            vm.onSiteRemoved({ index: index });
        }
    }

})();

